var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgComputer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#FF153D;}\r\n\t.st3{display:inline;fill:#FF153D;}\r\n\t.st4{fill:none;stroke:#FF153D;stroke-width:1.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23,30.2h-2c-1.1,0-2-0.8-2-1.8v-2.7h-6v2.7c0,1-0.9,1.8-2,1.8H9c-0.6,0-1,0.4-1,0.9C8,31.6,8.4,32,9,32h14 c0.6,0,1-0.4,1-0.9C24,30.6,23.6,30.2,23,30.2z M30.3,0H1.8C0.8,0,0,0.9,0,1.9v19.8c0,1.1,0.8,1.9,1.8,1.9h28.5 c1,0,1.8-0.9,1.8-1.9V1.9C32,0.9,31.2,0,30.3,0z M30,21.6H2V2.1h28V21.6z"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 18.6,
    className: "st3",
    width: 29.8,
    height: 3.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 86,
    height: 73,
    xlinkHref: "component (1).png",
    transform: "matrix(0.3423 0 0 0.3423 1.28 3.5051)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Camada_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29,24.3H3c-1,0-1.7-0.8-1.7-1.7V5.2c0-1,0.8-1.7,1.7-1.7h26c1,0,1.7,0.8,1.7,1.7v17.3 C30.7,23.5,29.9,24.3,29,24.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 19.7,
    className: "st2",
    width: 29.5,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.9,28.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23,30.1h-2c-1.1,0-2-0.7-2-1.6V26h-6v2.4c0,0.9-0.9,1.6-2,1.6H9c-0.6,0-1,0.4-1,0.8c0,0.4,0.4,0.8,1,0.8h14 c0.6,0,1-0.4,1-0.8C24,30.5,23.6,30.1,23,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.9,28.2"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgComputer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/computer.0b5398d1.svg";
export { ForwardRef as ReactComponent };